import { combineReducers } from 'redux'
import buyCards from './buyCards'
import visaCards from './visaCards'
import orderStatus from './orderStatus'
import algoliaSearch from './algoliaSearch'
import siteSearch from './siteSearch'
import buyBulkReducer from './buyBulk'
import { connectRouter } from 'connected-react-router'
import smbCartReducer from './smbCart'
import createACardReducer from './createACard'
import orderDetailsReducer from './orderDetails'

const createRootReducer = (history) =>
    combineReducers({
        router: connectRouter(history),
        buyCards: buyCards,
        visaCards: visaCards,
        algoliaSearch: algoliaSearch,
        orderStatus: orderStatus,
        siteSearch: siteSearch,
        buyBulk: buyBulkReducer,
        smbCart: smbCartReducer,
        createACard: createACardReducer,
        orderDetails: orderDetailsReducer,
    })

export default createRootReducer
